<template>
	<div class="box-description mt-5 mb-5">
		<div class="row">
			<div class="col-12 col-service-title">
				<h5>Planes de telefonía y datos móviles BlackFon®</h5>
			</div>

			<!-- BENEFICIOS -->
			<div class="col-12 col-benefits">
				<div class="row">
					<div class="order-0 col-12 col-subtitle">
						<h5>
							Cobertura nacional en la mayor parte de México con red propia 4.5
							G
						</h5>
					</div>

					<div class="order-1 col-6 col-sm-6 col-md-4 col-benefit">
						<div class="icons"><i class="fad fa-mobile-alt"></i></div>
						<p class="txt">
							Planes siempre controlados 
							<br /> sin excedentes
						</p>
					</div>

					<div class="order-4 order-sm-2 col-12 col-sm-6 col-md-4 col-benefit">
						<div class="icons fix-margins browsers">
							<!-- <i class="fab fa-chrome"></i> -->
							<!-- <i class="fab fa-firefox-browser"></i> -->
							<!-- <i class="fab fa-edge"></i> -->
							<!-- <i class="fab fa-safari"></i> -->
							<span class="imoon-some-radio"></span>
							<span class="imoon-facebook2"></span>
							<span class="imoon-instagram"></span>
							<span class="imoon-whatsapp"></span>
						</div>
						<p class="txt">
							Radio Prip® y redes 
							<br /> sociales ilimitadas
						</p>
					</div>

					<div class="order-3 col-6 col-sm-6 col-md-4 col-benefit">
						<div class="icons fix-margins signal">
							<span class="imoon-multi-carrier"></span>
							<i class="far fa-signal"></i>
						</div>
						<p class="txt">
							La mejor cobertura de tecnología
							<br />Multi-Carrier
						</p>
					</div>

					<div class="order-4 col-12 col-subtitle v2">
						<h5>Activa tu SIM o eSIM al instante</h5>
					</div>
				</div>
			</div>
			<!-- BENEFICIOS -->

			<offers-slider class="col-12 col-carousel" />

		</div>
	</div>
</template>

<script>
import offersSlider from '../../daniel/offers-slider.vue';

export default {

	components: { offersSlider },

	data() {
		return {
			// == Carousel options ==
			// == ==
		};
	},

};
</script>


<style scoped>
.fix-margins {
	display: flex;
	flex-flow: row nowrap;
	gap: 12px;
}
</style>